<template>
  <div style="width: 100%; height: 100%">
    <div class="all" :class="sidebarShow ? 'sidebar' : 'nosidebar'">
      <tabber
        class="tabber"
        @tabberClick="tabberClick"
        @iconClick="iconClick"
      ></tabber>
      <router-view />
      <bottom class="bottom"></bottom>
    </div>
    <div class="left" @click="sidebarShow = false" v-show="sidebarShow"></div>
    <div class="right all" :class="sidebarShow ? 'right-1' : 'right-2'">
      <div
        v-for="(item, index) in tabberList"
        :key="index"
        @click="tabberClick(item.path)"
        :class="$route.path == item.path ? 'pitch' : ''"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
import tabber from "@/components/tabber.vue";
export default {
  components: {
    tabber,
  },
  data() {
    return {
      sidebarShow: false,
      tabberList: [
        { title: "首页", path: "/home" },
        { title: "智慧能源", path: "/inteManufa" },
        { title: "人工智能", path: "/aipeople" },
        { title: "数字乡村", path: "/countryside" },
      ],
    };
  },
  methods: {
    tabberClick(path) {
      if (this.$route.path == path) {
        return;
      }
      this.sidebarShow = false;
      this.$router.replace(path);
    },
    iconClick() {
      this.sidebarShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.all {
  transition: all 0.1s linear;
}
.nosidebar {
  position: relative;
  left: 0px;
}
.sidebar {
  position: relative;
  left: -200px;
}
.left {
  top: 0px;
  left: 0px;
  position: fixed;
  z-index: 1000;
  width: calc(100% - 200px);
  height: 100%;
}
.right {
  top: 0px;
  // right: 0px;
  position: fixed;
  z-index: 1000;
  width: 200px;
  height: 100%;
  background-color: rgb(66, 66, 66);
  overflow: hidden;
  > div {
    margin-left: 30px;
    margin-top: 20px;
    color: white;
  }
  > div:nth-child(1) {
    margin-top: 60px;
  }

  .pitch {
    color: rgb(65, 140, 253);
  }
}
.right-1 {
  width: 200px;
  right: 0px;
}
.right-2 {
  width: 0px;
  right: 0px;
  > div {
    display: none;
  }
  // right: -200px;
}
</style>


// WEBPACK FOOTER //
// src/layout/index.vue